var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { action, computed, observable } from 'mobx';
import { ReportSorting, ReportState } from '../enums/ReportsEnums';
import { State } from '../models/Enums';
export class ReportsStore {
    constructor(network, companyId, userId) {
        this.hasSubsidaries = false;
        this.initialDataLoaded = false;
        this.numberOfDelivered = 0;
        this.numberOfOngoing = 0;
        this.numberOfWaitingApproval = 0;
        this.orderRecipientsFilter = order => {
            return (order.creatorId === this.userId ||
                (order.orderRecipientUser && order.orderRecipientUser.userId === this.userId));
        };
        this.network = network;
        this.companyId = companyId;
        this.userId = userId;
        this.searchString = '';
        this.sorting = ReportSorting.NewestFirst;
        this.activeStateFilter = ReportState.Done;
        this.orders = [];
        this.individuals = [];
    }
    //TODO: fix me!
    get amountNotReadReports() {
        if (this.initialDataLoaded) {
            return this.orders.filter((o) => !o.isRead).length;
        }
        else {
            return 0;
        }
    }
    init() {
        return __awaiter(this, void 0, void 0, function* () {
            const concernStructure = yield this.network.getConcernFlat(this.companyId);
            this.hasSubsidaries = (concernStructure === null || concernStructure === void 0 ? void 0 : concernStructure.length) > 1;
            console.log('Where is used (Obsolete)?');
            yield this.ensureConcernIndividuals(concernStructure);
            yield this.ensureOrdersInActiveState(concernStructure);
            yield this.mapObjectsToOrders();
        });
    }
    ensureOrdersInActiveState(concernStructure) {
        return __awaiter(this, void 0, void 0, function* () {
            const statesToFetch = this.determineStatesToGetOrdersFor();
            //we don't need to fetch order for any additional states.
            if (statesToFetch.length < 1) {
                return;
            }
            this.numberOfDelivered = 0;
            this.numberOfOngoing = 0;
            this.numberOfWaitingApproval = 0;
            const fetchedOrders = [];
            for (const index in concernStructure) {
                const subsidiary = concernStructure[index];
                const result = yield this.getCompanyOrdersByActiveState(subsidiary, statesToFetch);
                this.numberOfDelivered += result.numberOfDelivered;
                this.numberOfOngoing += result.numberOfOngoing;
                this.numberOfWaitingApproval += result.numberOfWaitingApproval;
                fetchedOrders.push(...result.orders.map(o => {
                    return Object.assign(Object.assign({}, o), { companyName: subsidiary.name });
                }));
            }
            this.orders.push(...fetchedOrders);
        });
    }
    ensureConcernIndividuals(concernStructure) {
        return __awaiter(this, void 0, void 0, function* () {
            //No need to fetch the individuals again
            if (this.individuals.length > 0) {
                return;
            }
            const fetchedIndividuals = [];
            for (const index in concernStructure) {
                const subsidiary = concernStructure[index];
                fetchedIndividuals.push(...yield this.getCompanyIndividals(subsidiary));
            }
            this.individuals = fetchedIndividuals;
        });
    }
    getCompanyIndividals({ id: companyId }) {
        return __awaiter(this, void 0, void 0, function* () {
            const allIndividuals = yield Promise.all([
                this.getIndividuals(companyId),
                this.getInternationalIndividuals(companyId)
            ]);
            return allIndividuals.flat();
        });
    }
    getCompanyOrdersByActiveState(company, states) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.network.getOrdersByStates(states, company.id);
        });
    }
    determineStatesToGetOrdersFor() {
        const statesToFetch = new Set(this.getStates());
        const cachedStates = new Set(this.orders.map(o => o.state));
        cachedStates.forEach(s => statesToFetch.delete(s));
        return [...statesToFetch];
    }
    getStates() {
        switch (this.activeStateFilter) {
            case ReportState.Archived:
                return [
                    State.Delivered,
                    State.Deleted
                ];
            case ReportState.Ongoing:
                return [
                    State.ResearchCompleted,
                    State.ConsentGiven,
                    State.ResearchInProgress,
                    State.WaitingForResearcher
                ];
            case ReportState.AwaitingApproval:
                return [
                    State.WaitingForConsent,
                    State.ConsentWithdrawn,
                    State.ConsentDeclined,
                    State.Received
                ];
            case ReportState.Done:
                return [
                    State.Delivered
                ];
        }
    }
    getIndividuals(companyId) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.network.getIndividualsByCompanyId(companyId);
        });
    }
    getInternationalIndividuals(companyId) {
        return __awaiter(this, void 0, void 0, function* () {
            return yield this.network.getIndividualsByCompanyId(companyId, true);
        });
    }
    mapObjectsToOrders() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.orders && this.individuals) {
                this.orders.forEach((order, index) => {
                    const individual = this.individuals.find(c => c.id === order.candidateId);
                    this.orders[index].candidate = individual;
                });
            }
            this.initialDataLoaded = true;
        });
    }
    get getVisibleOrders() {
        let res = this.orders;
        res = this.filterViaSearch(res, this.searchString);
        res = this.filterViaState(res, this.activeStateFilter);
        res = this.sortItems(res, this.sorting);
        return res.filter(o => !o.groupId);
    }
    get getGroupOrders() {
        let res = this.orders;
        res = this.filterViaSearch(res, this.searchString);
        res = this.filterViaState(res, this.activeStateFilter);
        res = this.sortItems(res, this.sorting);
        let ordersWithGroupId = res.filter(o => o.groupId);
        let distinctGroupIds = [...new Set(ordersWithGroupId.map(o => o.groupId))];
        let groupedOrders = this.groupOrdersByGroupId(ordersWithGroupId, distinctGroupIds);
        return groupedOrders;
    }
    groupOrdersByGroupId(orders, ids) {
        let result = [];
        for (const groupid of ids) {
            let group = {
                id: groupid,
                orders: orders.filter(o => o.groupId === groupid)
            };
            result.push(group);
        }
        return result;
    }
    sortItems(orders, sorting) {
        switch (sorting) {
            case ReportSorting.NewestFirst:
            default:
                return orders.sort((a, b) => new Date(b.delivered).getTime() - new Date(a.delivered).getTime());
        }
    }
    filterViaSearch(items, searchString) {
        searchString = searchString.toLowerCase();
        const matches = (str) => str.toLowerCase().indexOf(searchString) > -1;
        return items === null || items === void 0 ? void 0 : items.filter(({ candidate: { nationalId = { value: '', country: '' }, lastName = '', firstName = '' } = {}, companyName = '' }) => matches(nationalId.value) ||
            matches(firstName) ||
            matches(lastName) ||
            matches(firstName + ' ' + lastName) ||
            matches(lastName + ' ' + firstName) ||
            matches(companyName));
    }
    filterViaState(items, stateFilter) {
        return items === null || items === void 0 ? void 0 : items.filter(item => {
            switch (item.state) {
                case State.Delivered:
                    return stateFilter === ReportState.Done || stateFilter === ReportState.Archived;
                case State.ResearchCompleted:
                case State.ConsentGiven:
                case State.ResearchInProgress:
                case State.WaitingForResearcher:
                    return stateFilter === ReportState.Ongoing;
                case State.WaitingForConsent:
                case State.ConsentWithdrawn:
                case State.ConsentDeclined:
                case State.Received:
                    return stateFilter === ReportState.AwaitingApproval;
                case State.Deleted:
                    return stateFilter === ReportState.Archived;
            }
            return false;
        });
    }
    getAmountNewOrdersPerFilter(filter) {
        var _a;
        return (_a = this.filterViaState(this.orders, filter)) === null || _a === void 0 ? void 0 : _a.filter((item) => !item.isRead).length;
    }
    get currentSectionHasOrders() {
        var _a;
        return ((_a = this.filterViaState(this.orders, this.activeStateFilter)) === null || _a === void 0 ? void 0 : _a.length) > 0;
    }
}
__decorate([
    observable
], ReportsStore.prototype, "companyId", void 0);
__decorate([
    observable
], ReportsStore.prototype, "userId", void 0);
__decorate([
    observable
], ReportsStore.prototype, "hasSubsidaries", void 0);
__decorate([
    observable
], ReportsStore.prototype, "sorting", void 0);
__decorate([
    observable
], ReportsStore.prototype, "searchString", void 0);
__decorate([
    observable
], ReportsStore.prototype, "activeStateFilter", void 0);
__decorate([
    observable
], ReportsStore.prototype, "fetchSelectedOrderOptions", void 0);
__decorate([
    observable
], ReportsStore.prototype, "orders", void 0);
__decorate([
    observable
], ReportsStore.prototype, "individuals", void 0);
__decorate([
    observable
], ReportsStore.prototype, "initialDataLoaded", void 0);
__decorate([
    observable
], ReportsStore.prototype, "numberOfDelivered", void 0);
__decorate([
    observable
], ReportsStore.prototype, "numberOfOngoing", void 0);
__decorate([
    observable
], ReportsStore.prototype, "numberOfWaitingApproval", void 0);
__decorate([
    computed
], ReportsStore.prototype, "amountNotReadReports", null);
__decorate([
    action
], ReportsStore.prototype, "init", null);
__decorate([
    action
], ReportsStore.prototype, "getIndividuals", null);
__decorate([
    action
], ReportsStore.prototype, "getInternationalIndividuals", null);
__decorate([
    action
], ReportsStore.prototype, "mapObjectsToOrders", null);
__decorate([
    computed
], ReportsStore.prototype, "getVisibleOrders", null);
__decorate([
    computed
], ReportsStore.prototype, "getGroupOrders", null);
__decorate([
    computed
], ReportsStore.prototype, "currentSectionHasOrders", null);
